// Settings.js
import React from "react";
import EnableMFA from "../components/EnableMFA";

const Settings = () => {
  return (
    <div className="settings">
      <h1>Settings</h1>
      <h3>How to enable Two-Factor Authentication (2FA)</h3>
      <p>
        Follow these steps to enable 2FA using your preferred authenticator app:
      </p>

      <ol>
        <li>
          Install an authenticator app on your mobile device if you haven't
          already. Popular options include:
          <ul>
            <li>Google Authenticator</li>
            <li>Authy</li>
            <li>Duo Mobile</li>
            <li>Microsoft Authenticator</li>
            <li>FreeOTP</li>
          </ul>
        </li>
        <li>Open your authenticator app and scan the QR code provided.</li>
        <li>
          After scanning, your app will start generating time-based one-time
          passwords (TOTP).
        </li>
        <li>
          Enter the OTP generated by your app into the verification field to
          complete the setup.
        </li>
      </ol>

      <EnableMFA />
    </div>
  );
};

export default Settings;
